import CafeteriaStatistics from './lib/statistics';
import CafeteriaStatisticsSidebar from './lib/sidebar';

import PageTitle from 'components/pageTitle';

import * as S from './styles';
import * as T from 'common/types';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
// import AppLoading from "components/appLoading";

export default function CafeteriaStatisticsPage() {
  const { chart, menuList } = useTypedSelector((state) => state.Cafeteria);

  return (
    <S.Container>
      {/* The heading is drawn by the topbar, and this screen has no page-level
          action, so the head row that used to hold one is gone. */}
      <PageTitle title="Statistics" />

      {/*
       * The design's stats layout: the charts take the room, the controls take
       * a fixed rail beside them. It was `col-md-9` / `col-md-3` — Bootstrap
       * columns inside a styled-components product — with a `maxWidth: 350`
       * override on the sidebar card fighting the 25% the grid gave it.
       */}
      <S.Layout>
        <CafeteriaStatistics
          data={chart.data.data?.chart || []}
          totalOrders={chart.data.data?.totalOrders}
          month={chart.data.data?.month}
          items={menuList.data?.list?.map((item: T.Pages.CafeteriaListItem) => item.title)}
          error={chart.error}
          // loading={chart.loading}
        />

        <CafeteriaStatisticsSidebar cafeteriaList={menuList.data} />
      </S.Layout>

      {/* <AppLoading loading={chart.loading} /> */}
    </S.Container>
  );
}
